(() => {
  const mobile = window.matchMedia('(max-width: 767px)');
  const records = new Map();
  const sync = record => {
    const {slot, entries} = record;
    if (mobile.matches) {
      entries.forEach(({node}) => slot.append(node));
      slot.hidden = false;
    } else {
      entries.forEach(({node, marker}) => marker.before(node));
      slot.hidden = true;
    }
  };
  const mount = () => {
    document.querySelectorAll('[data-product-section]').forEach(section => {
      if (records.has(section)) return;
      const slot = section.querySelector('[data-mobile-product-heading]');
      const summary = section.querySelector('.product-summary');
      if (!slot || !summary) return;
      const entries = [...summary.children]
        .filter(node => node.matches('.eyebrow,.native-product-kind,h1.amazon-product-title,.native-inline-rating'))
        .map(node => {
          const marker = document.createTextNode('');
          node.before(marker);
          return {node, marker};
        });
      const record = {slot, entries};
      records.set(section, record);
      sync(record);
    });
    document.querySelectorAll('[data-collection-section]').forEach(section => {
      if (records.has(section)) return;
      const slot = section.querySelector('[data-mobile-collection-intro]');
      const node = section.querySelector('.collection-top .page-intro>.rte');
      if (!slot || !node) return;
      const marker = document.createTextNode('');
      node.before(marker);
      const record = {slot, entries: [{node, marker}]};
      records.set(section, record);
      sync(record);
    });
  };
  mobile.addEventListener('change', () => records.forEach(sync));
  document.addEventListener('shopify:section:load', mount);
  document.addEventListener('shopify:section:unload', event => {
    records.forEach((record, section) => {
      if (event.target === section || event.target.contains(section)) records.delete(section);
    });
  });
  mount();
})();
